import "./Login.module.css";
import Header from "@/reusable_sections/Header";
import UserLogin from "./sections/UserLogin";
import Footer from "@/reusable_sections/Footer";
export default function LoginPage() {
  return <div>
      <Header />
      <UserLogin />
      <Footer />
    </div>;
}